module.exports = __webpack_public_path__ + "static/media/Ningguang.d35a0a1d.png";